import React, { useReducer } from 'react';

const LanguageContext = React.createContext("sr_cyr");

const LanguageContextProvider = ({ children }) => {
    let initialState = "sr_cyr";

    const reducer = (state, action) => {
        switch (action.type) {
            case "en_gb":
                return "en_gb";

            case "sr_lat":
                return "sr_lat";

            default:
                return initialState;
        }
    };

    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <LanguageContext.Provider value={{ state, dispatch }}>
            {children}
        </LanguageContext.Provider>
    );
}

const LanguageConsumer = LanguageContext.Consumer;

export { LanguageContextProvider, LanguageConsumer, LanguageContext };